module.exports = __webpack_public_path__ + "static/media/Scan.a0528453.jpg";